import * as React from 'react';
import Loading from './Loading';
import { fetchRecords, fetchCost, downloadCsv } from '../logic/api/BizServer';
import RecordsForMonth from '../logic/domain/transits/RecordsForMonth';
import Record from '../logic/domain/transits/Record';
import Cost from '../logic/domain/cost/Cost';
import {
  updateRecord,
  deleteRecord,
  createRecord,
  addPath
} from '../logic/service/RecordsForMonthService';
import MonthView from './MonthView';
import { getYear, getMonth } from '../logic/util/DateTime';
import Failure from './Failure';
import CsvRecord from '../logic/domain/csv/CsvRecord';
import ErrorNotification from './ErrorNotification';
import pathToUpdate from '../logic/type/pathToUpdate';

interface Props {
  refreshToken: string;
}

interface State {
  isLoading: boolean;
  recordsForMonth: RecordsForMonth;
  thisMonth: number;
  hasCsvError: boolean;
}

class Main extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true,
      recordsForMonth: {
        date: '',
        transitListForDay: []
      },
      thisMonth: new Date().valueOf(),
      hasCsvError: false
    };
  }
  async componentDidMount() {
    const records = await this.fetchRecordsForMonth(this.state.thisMonth);
    this.setState({
      isLoading: false,
      recordsForMonth: records
    });
  }
  render() {
    const { isLoading, recordsForMonth, hasCsvError } = this.state;
    if (isLoading) {
      return <Loading />;
    }
    if (recordsForMonth.date !== '') {
      return (
        <div>
          {hasCsvError ? (
            <ErrorNotification
              closeError={() => this.setState({ hasCsvError: false })}
            />
          ) : (
            ''
          )}
          <MonthView
            recordsForMonth={recordsForMonth}
            handleCreateRecord={this.handleCreateRecord}
            handleUpdateRecord={this.handleUpdateRecord}
            handleDeleteRecord={this.handleDeleteRecord}
            handleCost={this.handleCost}
            handleCsv={this.handleCsv}
            operateMonth={this.operateMonth}
          />
        </div>
      );
    }
    return <Failure errorMessage="Cannot fetch data ..." />;
  }
  private handleCreateRecord = (path: pathToUpdate): void => {
    const created = createRecord(this.state.recordsForMonth, path);
    this.setState({
      recordsForMonth: created
    });
  };

  private handleUpdateRecord = (
    path: pathToUpdate,
    value: string | number
  ): void => {
    const updated = updateRecord(this.state.recordsForMonth, path, value);
    this.setState({
      recordsForMonth: updated
    });
  };

  private handleDeleteRecord = (path: pathToUpdate, index: number): void => {
    const deleted = deleteRecord(this.state.recordsForMonth, path);
    this.setState({
      recordsForMonth: deleted
    });
  };

  private operateMonth = async (operation: Function) => {
    this.setState({
      isLoading: true
    });
    const nextPrevious = operation
      ? operation(this.state.thisMonth, 1, 'month')
      : new Date().valueOf();
    const records = await this.fetchRecordsForMonth(nextPrevious);
    this.setState({
      isLoading: false,
      recordsForMonth: records,
      thisMonth: nextPrevious
    });
  };

  private handleCost = async (path: pathToUpdate, record: Record) => {
    const cost = await this.fetchCost(record);
    const costPath = addPath(path, ['cost']);
    const updated = updateRecord(this.state.recordsForMonth, costPath, cost);
    this.setState({
      recordsForMonth: updated
    });
  };

  private fetchRecordsForMonth = async (
    dateTime: number
  ): Promise<RecordsForMonth> => {
    const year = Number(getYear(dateTime));
    const month = Number(getMonth(dateTime));
    const records: RecordsForMonth = await fetchRecords(
      this.props.refreshToken,
      year,
      month
    );
    return records;
  };

  private fetchCost = async (record: Record): Promise<Cost> => {
    const cost = await fetchCost(record);
    return cost;
  };

  private validateRecord = (record: Record): boolean => {
    if (record === undefined) return false;
    if (record.from === undefined) return false;
    if (record.to === undefined) return false;
    if (record.cost === undefined) return false;
    return true;
  };

  private handleCsv = async (): Promise<CsvRecord[]> => {
    const csvRecords: CsvRecord[] = [];
    const recordsForMonth: RecordsForMonth = this.state.recordsForMonth;
    let hasCsvError = false;
    recordsForMonth.transitListForDay.map(item => {
      item.records.map(record => {
        if (this.validateRecord(record)) {
          csvRecords.push(
            new CsvRecord('電車', record.from, record.to, record.cost)
          );
        } else {
          hasCsvError = true;
        }
      });
      this.setState({
        hasCsvError
      });
    });
    const data = await downloadCsv(csvRecords);
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const url = window.URL.createObjectURL(new Blob([bom, data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'transits.csv');
    document.body.appendChild(link);
    link.click();
    return csvRecords;
  };
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.tsx